class OptionSelector extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-option-drawer-trigger]');
    this.dialog = this.querySelector('[data-option-drawer]');
    this.closeButtons = this.querySelectorAll('[data-option-drawer-close]');

    this.trigger?.addEventListener('click', this.open.bind(this));
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    if (!this.hasAttribute('data-manual-close')) {
      this.dialog?.addEventListener('change', () => this.close());
    }
    this.dialog?.addEventListener('cancel', () => {
      this.trigger?.setAttribute('aria-expanded', 'false');
    });
  }

  open() {
    if (!this.dialog || this.dialog.open) return;
    this.dialog.showModal();
    this.trigger?.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (!this.dialog?.open) return;

    this.dialog.classList.add('option-drawer--closing');
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      this.dialog.classList.remove('option-drawer--closing');
      this.dialog.close();
      this.trigger?.setAttribute('aria-expanded', 'false');
    };
    this.dialog.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 400);
  }
}

customElements.define('option-selector', OptionSelector);
